<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    :class="{ 'test-server-sidebar': isTestServer }"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>

      <CIcon
        custom-class-name="sidebar-brand-full"
        :icon="logoNegative"
        :height="35"
      />
      <!-- <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      /> -->
      
    </CSidebarBrand>
      <b v-if="!isProduction" class="text-center py-3">{{getHostName()}}</b>
    <AppSidebarNav />
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleSidebar')"
    />
    
  </CSidebar>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { AppSidebarNav } from "./AppSidebarNav";
import { logoNegative } from "@/assets/brand/logo-negative";
import { sygnet } from "@/assets/brand/sygnet";
export default {
  name: "AppSidebar",
  components: {
    AppSidebarNav,
  },
  data() {
    return {
      isProduction: true,
      isTestServer: false
    }
  },
  setup() {
    const store = useStore();
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    };
  },
  methods: {
    getHostName: function() {

      let hostname = window.location.hostname;
      if (hostname == 'testapp.byttgass.no') {
        this.isProduction = false
        this.isTestServer = true
        return 'TEST SERVER'
      } else if (hostname == 'localhost') {
        this.isProduction = false
        this.isTestServer = false
        return 'LOCALHOST'
      } else {
        this.isProduction = true
        this.isTestServer = false
      }
      
    }
  },
  mounted() {
    this.getHostName()
  }
};
</script>

<style scoped>
.test-server-sidebar {
  background-color: #b8860b !important; /* Dark goldenrod */
}

.test-server-sidebar .sidebar-brand {
  background-color: #9a7209 !important; /* Darker yellow for brand area */
}

.test-server-sidebar .nav-link {
  color: #ffffff !important;
}

.test-server-sidebar .nav-link:hover {
  background-color: #9a7209 !important;
  color: #ffffff !important;
}

.test-server-sidebar .nav-link.active {
  background-color: #856308 !important;
  color: #ffffff !important;
}

.test-server-sidebar .sidebar-toggler {
  background-color: #9a7209 !important;
  border-color: #856308 !important;
}
</style>